// extracted by mini-css-extract-plugin
module.exports = {"back":"DeviceTypeSelection_back__2Wshz","root":"DeviceTypeSelection_root__1aegp","mode1":"DeviceTypeSelection_mode1__2Ba6k","mode2":"DeviceTypeSelection_mode2__1q8xw"};